import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 首页-工作台未处理数量
export function indexGztWclCount(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/gztWclCount`,
    method: 'post',
    data,
  })
}
// 首页-党建引领
export function indexDjyl(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/djyl`,
    method: 'post',
    data,
  })
}
// 首页-综治力量
export function indexZzll(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/zzll`,
    method: 'post',
    data,
  })
}
// 首页-社会力量
export function indexShll(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/shll`,
    method: 'post',
    data,
  })
}


// 首页-处置调度-事件状态
export function czddSjzt(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/czdd/sjzt`,
    method: 'post',
    data,
  })
}
// 首页-处置调度-事件分类
export function czddSjfl(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/czdd/sjfl`,
    method: 'post',
    data,
  })
}
// 首页-处置调度-事件统计-折线图
export function czddSjtj(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/czdd/sjtj`,
    method: 'post',
    data,
  })
}



// 首页-基础数据9
export function indexJcsj9(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/jcsj9`,
    method: 'post',
    data,
  })
}
// 首页-基础数据x
export function indexJcsjx(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/jcsjx`,
    method: 'post',
    data,
  })
}
// 首页-风险摸排
export function indexFxmp(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/fxmp`,
    method: 'post',
    data,
  })
}
// 首页-数据统计
export function indexSjtj(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/index/${systemConfig.version_1}/sjtj`,
    method: 'post',
    data,
  })
}